import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@material-ui/core';
import Button from 'on_web/components/shared/Common/Button';
import { Typography } from '@material-ui/core';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';
import AssessmentSectionTitle from 'on_web/components/shared/AssessmentSectionTitle/AssessmentSectionTitle';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { ROUTE_ASSESSMENT_LIKELIHOOD } from 'routes';

function LikelihoodReportCard(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const useStyles = makeStyles(() => ({
    sectionTitle: {
      fontFamily: 'MuseoSans-500',
      fontSize: props.isDesktop ? 26 : 20,
      lineHeight: '30px',
      color: props.textColor,
      textAlign: props.isDesktop ? 'left' : 'center',
    },
    riskLevel: {
      fontFamily: 'MuseoSans-900',
      fontSize: 25,
      lineHeight: '30px',
      color: props.textColor,
      textAlign: props.isDesktop ? 'left' : 'center',
      textTransform: 'uppercase',
    },
    percentage: {
      fontSize: props.isDesktop ? '65px' : '55px',
      color: props.textColor,
      fontFamily: 'Museo-900',
    },
  }));

  const classes = useStyles();

  return (
    <>
      <AssessmentSectionTitle isDesktop={props.isDesktop} title={props.title} />
      <Box
        style={{
          paddingLeft: '20px',
          paddingRight: '20px',
          paddingBottom: '20px',
          marginTop: '14px',
          borderBottom: '1px Solid #efefef',
        }}
      >
        {!props.isDesktop && (
          <>
            <Box
              className={classes.sectionTitle}
              display={'block'}
              textAlign={'center'}
            >
              {props.sectionTitle}
            </Box>
            <Box className={classes.riskLevel}>{props.sectionSubtitle}</Box>
            <Box display={'block'} textAlign={'center'}>
              {props.illustration}
            </Box>
          </>
        )}

        {props.isDesktop && (
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
          >
            <Grid item xs={6}>
              <>
                <Box className={classes.sectionTitle}>{props.sectionTitle}</Box>
                <Box className={classes.riskLevel} paddingBottom={4}>
                  {props.sectionSubtitle}
                </Box>
              </>
            </Grid>

            <Grid item xs={6}>
              <Box display={'block'} textAlign={'center'}>
                {props.illustration}
              </Box>
            </Grid>
          </Grid>
        )}

        <Box display="flex" justifyContent="flex-start">
          <Button
            endIcon={<NavigateNextIcon />}
            variant="text"
            onClick={() => {
              trackEvent('Reporting', 'Learn more about Likelihood');
              history.push({
                pathname: ROUTE_ASSESSMENT_LIKELIHOOD,
                state:
                  props.responseHealthBasedRisks && props.responseLikelihood
                    ? {
                        healthBasedRisks: props.responseHealthBasedRisks,
                        infectionLikelihood: props.responseLikelihood,
                      }
                    : null,
              });
            }}
          >
            <Typography variant="h7">
              {t('reporting.myAssessment.learnMore')}
            </Typography>
          </Button>
        </Box>
      </Box>
    </>
  );
}

LikelihoodReportCard.propTypes = {
  /**
   * Indicates whether used resolution is for desktop.
   */
  isDesktop: PropTypes.bool.isRequired,

  /**
   * Color to be used for title and subtitle.
   */
  textColor: PropTypes.string.isRequired,

  /**
   * Title explaining likelihood.
   */
  sectionTitle: PropTypes.string.isRequired,

  /**
   * Subtitle representing likelihood.
   */
  sectionSubtitle: PropTypes.string.isRequired,

  /**
   * Illustration showing likelihood.
   */
  illustration: PropTypes.node.isRequired,
};

export default LikelihoodReportCard;
